import React from 'react'

interface ErrorMessageProps {
    message: string
    textStyle?: string
    setH?: string
}

export default function ErrorMessage({ message, textStyle, setH }: ErrorMessageProps) {
    return (
        <div className={`flex justify-center items-center ${setH?.length === 0 ? 'h-64' : ''}`}>
            <p className={`${textStyle === '' ? 'text-red-500' : textStyle} font-medium text-center`}>
                {message}
            </p>
        </div>
    )
}
